import type React from "react";

export const CricketIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 128 128"
      {...restProps}
    >
      <title>Cricket Icon</title>
      <g>
        <path
          d="M121.26 15.27 91.73 44.81a.58.58 0 0 0-.1.12l-8.47-8.48c0-.06.11-.1.16-.15l29.49-29.48zM127.56 8.29 119.78.52a1.48 1.48 0 0 0-2.11 0l-3.17 3.17a1.48 1.48 0 0 0-.44 1.05 1.4 1.4 0 0 0 .15.64l8.48 8.49a1.5 1.5 0 0 0 1.7-.29l3.17-3.17a1.49 1.49 0 0 0 0-2.12zM90.35 50.4a5.39 5.39 0 0 1 .17-3.77l-9.09-9.09a5.43 5.43 0 0 1-3.83.1 13 13 0 0 1-3.39-1.8 3.06 3.06 0 0 0-4 .3L1.5 104.85a5 5 0 0 0-1.09 5.52 36.06 36.06 0 0 0 17.13 17.15 5 5 0 0 0 1.93.4 5.08 5.08 0 0 0 3.6-1.51l68.7-68.71a3 3 0 0 0 .31-4 11.75 11.75 0 0 1-1.73-3.3zM67.2 103.91a10 10 0 1 0 10 10 9.94 9.94 0 0 0-10-10z"
          fill={color}
        />
      </g>
    </svg>
  );
};
